/**
 * @description 预配送取消率
 *
 * @props {string} 
 *
 * @slot {插槽} 
 *
 */
<template>
  <div class="content">
    <div class="title">
      <span class="rate">预配送取消率</span>
      <span class="target">目标：低于 2.5%</span>
    </div>
    <div class="main">
      <div class="detalis1">
        <div class="item-cell date">
          <span class="day">时间范围：{{ preFulfillmentCancellation.duration }}天</span>
          <span>{{ preFulfillmentCancellation.timeFrameStart | convertToDate}} - {{ preFulfillmentCancellation.timeFrameEnd | convertToDate }}</span>
        </div>
        <div class="item-cell rate" :class="{abnormal: !preFulfillmentCancellation.completeTarget}">{{ preFulfillmentCancellation.rate }}</div>
        <div class="item-cell">
          <span>卖家取消的订单数：</span>
          <span>{{ preFulfillmentCancellation.count }}</span>
        </div>
        <div class="item-cell">
          <span>订单总数：</span>
          <span>{{ preFulfillmentCancellation.totalCount }}</span>
        </div>
      </div>
      <div class="detalis2"></div>
      <div class="message" v-if="explain">
        <div class="message-cell" v-for="(item, index) in message" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertToDate } from "@/utils/date.util"
export default {
  props: {
    explain: {
      type: Boolean,
      default: true
    },
    preFulfillmentCancellation: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      message: [
        "取消率(CR)是在给定的7天时间段内，卖家取消的所有订单数占订单总数的百分比。CR仅适用于卖家自配送订单。",
        "此指标包括所有由卖家取消的订单，但买家使用其亚马逊账户中的订单取消选项请求取消的订单除外。买家在亚马逊上直接取消的等待中订单不包括在内。",
        "亚马逊的政策规定，卖家需维持低于 2.5% 的 CR，才能在亚马逊上销售商品。 高于 2.5%的 CR 可能会导致账户停用。"
      ],
    };
  },
  filters: {
    convertToDate(val) {
      if (!val) { return "" }
      return convertToDate(new Date(val))
    }
  }
};
</script>

<style scoped lang="scss">
.abnormal {
  color: #F56C6C !important;
}
.content {
  line-height: 1;
  padding-bottom: 40px;
  .title {
    padding: 20px 0;
    .rate {
      padding: 0 15px 0 20px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
    }
    .target {
      color: #666;
      font-size: 12px;
    }
  }
  .main {
    display: flex;
    .detalis1 {
      width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      .item-cell {
        width: 180px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-left: 40px;
        padding-bottom: 22px;
        &.rate {
          font-size: 24px;
          color: #333;
          font-weight: 600;
          padding: 10px 0 22px 40px;
        }
        &.date {
          width: 250px;
          font-size: 12px;
          padding-left: 0;
          .day {
            padding-right: 15px;
          }
        }
        &:last-child {
          padding-bottom: 0;
        }
      }
    }
    .detalis2 {
      width: 30%;
      border-left: 1px solid #ccc;
    }
    .message {
      border-left: 1px solid #ccc;
      width: 40%;
      font-size: 12px;
      color: #666;
      line-height: 20px;
      padding-right: 26px;
      padding-left: 30px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
  }
}
</style>